export default __webpack_public_path__ + "static/media/uae.fb76a89a.png";